import { render, staticRenderFns } from "./ContractRatesForm.vue?vue&type=template&id=648644bc&scoped=true&"
import script from "./ContractRatesForm.vue?vue&type=script&lang=js&"
export * from "./ContractRatesForm.vue?vue&type=script&lang=js&"
import style0 from "./ContractRatesForm.vue?vue&type=style&index=0&id=648644bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648644bc",
  null
  
)

export default component.exports